import type { QmsColumn, QmsTicketStatus, QmsTicketType } from '../types/qms.types';

export interface QmsBoardColumnDefinition extends Omit<QmsColumn, 'title'> {
  titleKey: string;
}

export const QMS_STANDARD_STATUSES = [
  'submitted',
  'in_progress',
  'ready_to_test',
  'complete',
  'validated_closed',
] as const;

export const QMS_CLIENT_STATUSES = [
  'client_submitted',
  'in_progress',
  'pending_review',
  'approved',
  'closed',
] as const;

export const QMS_MOVABLE_STATUSES: readonly QmsTicketStatus[] = [
  ...QMS_STANDARD_STATUSES,
  'client_submitted',
  'pending_review',
  'approved',
  'closed',
];

export const QMS_BOARD_COLUMNS: readonly QmsBoardColumnDefinition[] = [
  { key: 'ticket_submitted', titleKey: 'columns.ticketSubmitted', type: 'ticket', status: 'submitted' },
  { key: 'ticket_in_progress', titleKey: 'columns.ticketInProgress', type: 'ticket', status: 'in_progress' },
  { key: 'ticket_ready_to_test', titleKey: 'columns.ticketReadyToTest', type: 'ticket', status: 'ready_to_test' },
  { key: 'ticket_complete', titleKey: 'columns.ticketComplete', type: 'ticket', status: 'complete' },
  { key: 'ticket_validated', titleKey: 'columns.ticketValidated', type: 'ticket', status: 'validated_closed' },
  { key: 'capa_submitted', titleKey: 'columns.capaSubmitted', type: 'capa', status: 'submitted' },
  { key: 'capa_in_progress', titleKey: 'columns.capaInProgress', type: 'capa', status: 'in_progress' },
  { key: 'capa_ready_to_test', titleKey: 'columns.capaReadyToTest', type: 'capa', status: 'ready_to_test' },
  { key: 'capa_complete', titleKey: 'columns.capaComplete', type: 'capa', status: 'complete' },
  { key: 'capa_validated', titleKey: 'columns.capaValidated', type: 'capa', status: 'validated_closed' },
  { key: 'client_submitted', titleKey: 'columns.clientSubmitted', type: 'client', status: 'client_submitted' },
  { key: 'client_in_progress', titleKey: 'columns.clientInProgress', type: 'client', status: 'in_progress' },
  { key: 'client_pending_review', titleKey: 'columns.clientPendingReview', type: 'client', status: 'pending_review' },
  { key: 'client_approved', titleKey: 'columns.clientApproved', type: 'client', status: 'approved' },
  { key: 'client_closed', titleKey: 'columns.clientClosed', type: 'client', status: 'closed' },
];

export function isQmsMovableStatus(status: string): status is QmsTicketStatus {
  return QMS_MOVABLE_STATUSES.includes(status as QmsTicketStatus);
}

export function getQmsColumnStatusSuffix(status: QmsTicketStatus): string {
  if (status === 'validated_closed') return 'validated';
  if (status === 'client_submitted') return 'submitted';
  return status;
}

export function getQmsColumnKey(type: QmsTicketType, status: QmsTicketStatus): string {
  return `${type}_${getQmsColumnStatusSuffix(status)}`;
}
